export const CHAT_TIME_SEPARATOR_INTERVAL_MS = 5 * 60 * 1000;

export function shouldShowChatSenderNickname(sessionType) {
  return sessionType === 'group';
}

export function shouldShowChatTimeSeparator(currentTimestamp, previousTimestamp) {
  if (!Number.isFinite(currentTimestamp) || currentTimestamp <= 0) {
    return false;
  }
  if (!Number.isFinite(previousTimestamp)) {
    return true;
  }
  return currentTimestamp - previousTimestamp >= CHAT_TIME_SEPARATOR_INTERVAL_MS;
}

export function formatChatTimelineTime(timestamp, now = Date.now()) {
  const date = new Date(timestamp);
  const current = new Date(now);
  const twoDigits = (value) => String(value).padStart(2, '0');
  const clock = `${twoDigits(date.getHours())}:${twoDigits(date.getMinutes())}`;
  const sameDay = date.getFullYear() === current.getFullYear()
    && date.getMonth() === current.getMonth()
    && date.getDate() === current.getDate();

  if (sameDay) {
    return clock;
  }

  const monthAndDay = `${twoDigits(date.getMonth() + 1)}-${twoDigits(date.getDate())}`;
  return date.getFullYear() === current.getFullYear()
    ? `${monthAndDay} ${clock}`
    : `${date.getFullYear()}-${monthAndDay} ${clock}`;
}
